module.exports = require('../../es/symbol');

require('../../modules/esnext.symbol.dispose');
require('../../modules/esnext.symbol.observable');
require('../../modules/esnext.symbol.pattern-match');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/features/symbol/index.js
// module id = 558
// module chunks = 0